import React from "react";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { handleCancelButtonClick } from "./SiteAboutPageUtils/handleCancelButtonClick";
import {
  SiteSchedule,
  SiteInfo,
  WireGuardTunnel,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const CancelButton = ({
  setEditMode,
  clickedTab,
  setActiveTab,
  siteInfo,
  setRecordingServerPatchObject,
  healthCheckData,
  webhooksInfo,
  siteInfoBackup,
  setSiteInfo,
  vmsVariablesBackup,
  setVmsVariables,
  wireguardTunnels,
  wireguardTunnelsLoading,
  selectedWireguardTunnelId,
  setSelectedWireguardTunnelId,
  clearWireGuardEditSession,
  setWireguardChangesMade,
}: {
  setEditMode: Dispatcher<boolean>;
  clickedTab: string;
  setActiveTab: Dispatcher<JSX.Element>;
  siteInfo: SiteInfo;
  setRecordingServerPatchObject: any;
  healthCheckData: any;
  webhooksInfo: any;
  siteInfoBackup: any;
  setSiteInfo: any;
  vmsVariablesBackup: any;
  setVmsVariables: any;
  wireguardTunnels: WireGuardTunnel[];
  wireguardTunnelsLoading: boolean;
  selectedWireguardTunnelId: number | null;
  setSelectedWireguardTunnelId: React.Dispatch<
    React.SetStateAction<number | null>
  >;
  clearWireGuardEditSession: () => void;
  setWireguardChangesMade: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { backupSiteSchedules, setSiteSchedules } =
    useSiteAboutStore.getState();

  return (
    <div>
      <OrangeTextButton
        onClick={() =>
          handleCancelButtonClick(
            setEditMode,
            clickedTab,
            setActiveTab,
            backupSiteSchedules,
            siteInfo,
            setRecordingServerPatchObject,
            healthCheckData,
            webhooksInfo,
            siteInfoBackup,
            setSiteInfo,
            vmsVariablesBackup,
            setVmsVariables,
            setSiteSchedules,
            wireguardTunnels,
            wireguardTunnelsLoading,
            selectedWireguardTunnelId,
            setSelectedWireguardTunnelId,
            clearWireGuardEditSession,
            setWireguardChangesMade
          )
        }
        text="CANCEL"
        disabled={false}
      />
    </div>
  );
};
